// extracted by mini-css-extract-plugin
export var aircallIframe = "_gk-3";
export var fabContainer = "_gk-5";
export var fabRinging = "_gk-6";
export var loadingOverlay = "_gk-4";
export var pulse = "_gk-7";
export var widgetContent = "_gk-2";
export var widgetPanel = "_gk-0";
export var widgetPanelExpanded = "_gk-1";